module.exports = __webpack_public_path__ + "img/yunyingfenxi.518a498e.svg";